/**
 * Export `truncateAddress`.
 */

export function truncateAddress(address: string | undefined, start = 4, end = 4) {
  if (!address) {
    return address;
  }

  const size = address.length - 1;

  return [
    address.substring(0, start + 2), // 0x chars.
    '...',
    address.substring(size - end, size)
  ].join('');
}

export function translateField(value: { [locale in string]: string } | string | undefined | null, language = 'pt') {
  try {
    if (!value) {
      return value;
    }

    const result = typeof value === 'string' ? JSON.parse(value) : value;

    return result?.[language] ?? result?.pt;
  } catch (error) {
    return value;
  }
}
